<template>
    <input class="ui-input-base-text"
        v-bind:class="{
            _focused: isFocused,
            _disabled: isDisabled,
            _invalid: isInvalid,
            _phone: isPhone,
        }"
        v-bind:value="valueFormatted"
        v-bind:type="type"
        v-bind:placeholder="placeholder"
        v-bind:autofocus="isAutofocus"
        v-bind:disabled="isDisabled"
        v-on:focus="focusHandler"
        v-on:blur="blurHandler"
        v-on="handler"
        ref="input"
    />
</template>

<script>
export default {
    name: 'ui-input-base-text',
    props: {
        value: {
            type: String,
            default: '',
        },
        type: {
            type: String,
            default: 'text',
        },
        placeholder: {
            type: String,
            default: '',
        },
        isAutofocus: {
            type: Boolean,
            default: false,
        },
        isDisabled: {
            type: Boolean,
            default: false,
        },
        isInvalid: {
            type: Boolean,
            default: false,
        },
        formatDown: {
            type: Function,
            default: null,
        },
        formatUp: {
            type: Function,
            default: null,
        },
        onInput: {
            type: Function,
            default: null,
        },
        onFocus: {
            type: Function,
            default: null,
        },
        onBlur: {
            type: Function,
            default: null,
        },
        errors: {
            type: Object,
            default: null,
        },
        isLazy: {
            type: Boolean,
            dafault: false,
        },
        isPhone: {
            type: Boolean,
            dafault: false,
        },
    },
    model: {
        prop: 'value',
        event: 'input',
    },
    data: () => ({
        isFocused: false,
    }),
    computed: {
        handler() {
            let result = {};
            if (this.isLazy) {
                result.change = this.inputHandler;
            } else {
                result.input = this.inputHandler;
            }
            return result;
        },
        valueFormatted() {
            return this.formatDown ? this.formatDown(this.value) : this.value;
        },
    },
    methods: {
        focusHandler(e) {
            if (this.onFocus !== null) {
                this.onFocus(e);
            }
            this.isFocused = true;
        },
        blurHandler(e) {
            if (this.onBlur !== null) {
                this.onBlur(e);
            }
            this.isFocused = false;
        },
        inputHandler(e) {
            if (this.onInput !== null) {
                this.onInput(e);
            }
            if (this.formatDown) {
                e.target.value = this.formatDown(e.target.value);
            }
            this.$emit('input', this.formatUp ? this.formatUp(e.target.value) : e.target.value);
        },
    },
    mounted() {
        if (this.isAutofocus) {
            this.$refs.input.focus();
        }
    },
};
</script>

<style scoped lang="less">
@import "~theme";

.ui-input-base-text {
    .typography-input();

    display: block;
    width: 100%;
    padding: 12px 12px 8px;
    border-radius: 0;

    background-color: transparent;

    box-shadow: inset 0 0 0 1px @color-gray-darkest;

    transition: box-shadow @duration-fast @easing-default;
    // &._focused {
    //     box-shadow: inset 0 0 0 1px @color-gray-darkest, 0 0 0 2px @color-gray-darkest;
    // }
    &._invalid,
    &._focused._invalid {
        box-shadow: inset 0 0 0 1px @color-accent-warm;
    }
    &._disabled {
        color: @color-gray-dark;
    }
    &::placeholder {
        color: @color-gray-dark;
    }
    &._phone::placeholder {
        color: @color-gray-darkest;
    }
    &:focus::placeholder {
        color: transparent;
    }
}
</style>
